import { render, staticRenderFns } from "./Aperitivore.vue?vue&type=template&id=a16b170e&scoped=true&"
import script from "./Aperitivore.vue?vue&type=script&lang=js&"
export * from "./Aperitivore.vue?vue&type=script&lang=js&"
import style0 from "./Aperitivore.vue?vue&type=style&index=0&id=a16b170e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16b170e",
  null
  
)

export default component.exports